import React from "react";

function Icon({ viewBox = "0 0 24 24", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" strokeWidth={2} fill="none" viewBox={viewBox} className={className}>
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" clipPath="url(#clip0_7698_24)">
        <path d="M.75 14.25h4.5M8.562 3a3.75 3.75 0 016.876 0M5.634 9.75H5.25a4.5 4.5 0 01-4.5-4.5M5.634 18.75H5.25a4.5 4.5 0 00-4.5 4.5M23.25 14.25h-4.5M18.366 9.75h.384a4.5 4.5 0 004.5-4.5M18.366 18.75h.384a4.5 4.5 0 014.5 4.5"></path>
        <path d="M18.75 12a6.75 6.75 0 00-13.5 0v4.5a6.75 6.75 0 0013.5 0V12z"></path>
      </g>
      <defs>
        <clipPath id="clip0_7698_24">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
